<template>
    <div class="w-100 rwg-page">
        <div class="rwg-page__shell">
            <loader-component v-if="loading" />
            <div v-else-if="error" class="alert alert-danger">
                {{ error }}
            </div>
            <div class="default-home" v-else>
                <div class="rwg-page__header">
                    <div>
                        <span class="rwg-page__eyebrow">Google</span>
                        <h5 class="title rwg-page__title">{{ $tl("labels.routes.rwg") }}</h5>
                        <p class="rwg-page__subtitle">Configurez l’accès Réserver avec Google pour vos établissements éligibles.</p>
                    </div>
                </div>
                <div class="row m-0 rwg-page__grid">
                    <restaurant-card
                        :clickable="canEditRwg(restaurant.id)"
                        v-tooltip="cantEditRwgTooltip(restaurant.id)"
                        @click="contractRwg(restaurant)"
                        v-for="restaurant in restaurants"
                        :key="restaurant.id"
                        :restaurant="restaurant"
                        class="col-md-4 mb-3" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoaderComponent from "../../../components/LoaderComponent.vue";
import RolesEnum from "../../../mixins/enums/RolesEnum.js";
import RestaurantCard from "./RestaurantCard.vue";

export default {
    data() {
        return {
            error: null,
            loading: false,
            restaurants: [],
        };
    },
    mixins: [RolesEnum],
    computed: {
        isOwner() {
            return this.$store.getters["users/role"] === this.ROLE_OWNER.value;
        },
    },
    methods: {
        cantEditRwgTooltip(restaurantId) {
            if (this.canEditRwg(restaurantId)) {
                return undefined;
            }

            return this.getTooltip(this.$tl("infos.booking.googleReserve.forRestaurantsOnly", restaurantId), { triggers: ["click", "hover"] });
        },
        canEditRwg(restaurantId) {
            const restaurant = this.$store.getters["restaurants/findRestaurantById"](restaurantId);

            return this.isOwner && typeof restaurant !== "undefined" && restaurant.feat_reserve_with_google;
        },
        fetchRestaurants() {
            this.error = null;
            this.loading = true;
            this.restaurants = [];

            this.$store
                .dispatch("restaurants/fetchAllRestaurants")
                .then((response) => {
                    this.restaurants = response.data.data;
                    if (this.isClubMedOwnerId(this.$store.getters["users/ownerId"])) {
                        this.restaurants.sort((a, b) => a.name.localeCompare(b.name));
                    }
                })
                .catch((error) => {
                    this.error = this.getErrorMsgFromErrorResponse(error);
                })
                .finally(() => (this.loading = false));
        },
        contractRwg(restaurant) {
            if (!this.canEditRwg(restaurant.id)) {
                return;
            }

            this.$router.push({ name: "restaurants.reserve_with_google.edit", params: { restaurant_id: restaurant.id } });
        },
    },
    created() {
        if (!this.isReserveWithGoogleEnabled()) {
            console.error("Reserve with Google is not available");
            return;
        }

        this.fetchRestaurants();
    },
    components: {
        LoaderComponent,
        RestaurantCard,
    },
};
</script>

<style scoped>
.rwg-page {
    min-height: calc(100vh - 72px);
    padding: 28px 18px 40px;
    background: linear-gradient(180deg, #f7fbfc 0%, #eef8fa 100%);
}

.rwg-page__shell {
    max-width: 1080px;
    margin: 0 auto;
}

.rwg-page__header {
    margin-bottom: 18px;
}

.rwg-page__eyebrow {
    display: inline-flex;
    margin-bottom: 8px;
    color: var(--main-color-light, #30a4b7);
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
}

.rwg-page__title {
    margin: 0;
    color: #142f3c;
    font-size: 1.45rem;
    font-weight: 700;
}

.rwg-page__subtitle {
    margin: 8px 0 0;
    color: #6c7f88;
}

.rwg-page__grid {
    margin-left: -8px !important;
    margin-right: -8px !important;
}

.rwg-page__grid > [class*="col-"] {
    padding-left: 8px;
    padding-right: 8px;
}

@media (max-width: 767.98px) {
    .rwg-page {
        padding: 20px 12px 32px;
    }
}
</style>
